module.exports = __webpack_public_path__ + "assets/img/delete.09d33818.svg";